export default __webpack_public_path__ + "static/media/Jenne Alderks.09bb33d0.png";